import React from 'react';
// components
import Form from '../../../components/Form/Form';
import FieldError from '../../../components/Form/FieldError';
import FormErrors from '../../../components/Form/FormErrors';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import RadioGroup from '../../../components/RadioGroup/RadioGroup';
import Select from '../../../components/Select/Select';
// utils
import moment from 'moment';
import { toast } from 'react-toastify';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { responseErrors } from '../../../utils/response';
import classnames from 'classnames/bind';
import styles from '../UserProfile.mod.css';

const cx = classnames.bind(styles);

export const PersonalInfoForm = ({
  values,
  touched,
  errors = {},
  dirty,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  handleReset,
  setFieldValue,
  setFieldTouched,
  color,
}) => {
  const currentYear = moment().year();
  const findValue = (val = currentYear) =>
    yearsOptions().find(({ value }) => value === val);
  const yearsOptions = () => {
    const options = [];
    for (let i = currentYear; i >= currentYear - 100; i--) {
      options.push({ value: i, label: `${i}` });
    }

    return options;
  };
  const birthdateValue = findValue(moment(values.birthdate).year());
  const birthdateOnChange = select => {
    select &&
      setFieldValue(
        'birthdate',
        moment()
          .year(select.value)
          .dayOfYear(1)
      );
  };
  const birthdateOnBlur = () => setFieldTouched('birthdate', true);

  return (
    <Form horizontal onSubmit={handleSubmit}>
      <FormErrors errors={errors} />

      {/* name */}
      <div className="form-control">
        <label className="label" htmlFor="name" style={{ width: '150px' }}>
          Username
        </label>
        <div className="field-wrapper">
          <Input
            name="username"
            placeholder="Jack Sparrow"
            value={values.username}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={errors.username && touched.username}
          />
          <FieldError error={errors.username} touched={touched.username} />
        </div>
      </div>

      {/* gender */}
      <div className="form-control">
        <label className="label" htmlFor="email" style={{ width: '150px' }}>
          Gender
        </label>
        <div className="field-wrapper">
          <RadioGroup
            name="gender"
            onChange={handleChange}
            value={values.gender}
            options={[
              { label: 'Male', value: 'male' },
              { label: 'Female', value: 'female' },
              { label: 'Prefer not to say', value: 'non_binary' },
            ]}
          />
          <FieldError error={errors.gender} touched={touched.gender} />
        </div>
      </div>

      {/* birthdate */}
      <div className="form-control">
        <label className="label" htmlFor="birthdate" style={{ width: '150px' }}>
          Birthdate
        </label>
        <div className="field-wrapper">
          <Select
            className={cx('year-select')}
            isCreatable={false}
            name="birthdate"
            value={birthdateValue}
            options={yearsOptions()}
            onChange={birthdateOnChange}
            defaultInputValue={findValue()}
            onBlur={birthdateOnBlur}
            invalid={touched.birthdate && errors.birthdate}
            placeholder="Select a year..."
            clearRenderer={() => null}
          />
          <FieldError error={errors.birthdate} touched={!!touched.birthdate} />
        </div>
      </div>

      {/* email */}
      <div className="form-control">
        <label className="label" htmlFor="email" style={{ width: '150px' }}>
          Email
        </label>
        <div className="field-wrapper">
          <Input
            name="email"
            placeholder="example@example.com"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            invalid={errors.email && touched.email}
            readOnly
          />
          <FieldError error={errors.email} touched={touched.email} />
        </div>
      </div>

      <Button
        type="submit"
        isLoading={isSubmitting}
        disabled={isSubmitting}
        color={color}
      >
        Save
      </Button>
      <Button
        type="reset"
        link
        onClick={handleReset}
        disabled={!dirty || isSubmitting}
      >
        Discard changes
      </Button>
    </Form>
  );
};

export default withFormik({
  mapPropsToValues: ({ user: { username, gender, email, birth_date } }) => ({
    username: username,
    gender: gender,
    email: email,
    birthdate: moment(birth_date),
  }),
  validationSchema: yup.object().shape({
    username: yup
      .string()
      .trim()
      .required('Username is required!'),
    gender: yup
      .string()
      .trim()
      .required('Gender is required!'),
    email: yup
      .string()
      .email('Invalid email address!')
      .required('Email is required!'),
    birthdate: yup
      .date()
      .max(
        new Date(new Date().setFullYear(new Date().getFullYear() - 16)),
        'You must be older than 16 or younger than 100 years old.'
      )
      .required('Date is required!'),
  }),
  handleSubmit: (
    values,
    { setSubmitting, setErrors, props: { user, onSubmit } }
  ) => {
    onSubmit({
      id: user.id,
      data: {
        ...values,
        birth_date: values.birthdate.toString(),
      },
    })
      .then(() => {
        setSubmitting(false);
        toast.success('User info successfully updated.');
      })
      .catch(response => {
        setSubmitting(false);
        setErrors(responseErrors(response));
      });
  },
  displayName: 'PersonalInfoForm',
})(PersonalInfoForm);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/components/PersonalInfoForm.jsx